import grid from "@/assets/icons/grid.svg";
import columns from "@/assets/icons/columns.svg";
import close from "@/assets/icons/close.svg";
import open from "@/assets/icons/open.svg";
import EniLogo from "@/assets/icons/EniLogo.svg";
import share from "@/assets/icons/share.svg";
import downArrow from "@/assets/icons/downArrow.svg";
import rightArrow from "@/assets/icons/rightArrow.svg";
import download from "@/assets/icons/download.svg";
import chain from "@/assets/icons/chain.svg";
import play from "@/assets/icons/play.svg";
import leftArrow from "@/assets/icons/leftArrow.svg";
import vectorLeft from "@/assets/icons/vectorLeft.svg";
import vectorRight from "@/assets/icons/vectorRight.svg";
import filter from "@/assets/icons/filter.svg";
import gallery from "@/assets/icons/gallery.svg";

export const pageIcons = {
  share,
  grid,
  columns,
  close,
  open,
  EniLogo,
  downArrow,
  rightArrow,
  download,
  chain,
  play,
  leftArrow,
  vectorLeft,
  vectorRight,
  filter,
  gallery,
};
